import { createContext } from 'react';
import { TPagedDialogContext } from '@types';

export const PagedDialogContext = createContext<TPagedDialogContext | null>(null);
